import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SearchForm from "../../component/search-form";
import moment from "moment/moment";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../component/modal-popup/customeModal";
// Redux
import { useDispatch, useSelector } from "react-redux";
import {
  getConfigurationData,
  handleDeleteConfiguration,
} from "../../redux/actions/configurationAction";
import {
  WORKFLOW_HEADER_NAME,
  GET_CONFIGURATION_BY_COMPANY_ID,
  REMOVE_CONFIGURATION_ID,
  SET_WORKFLOW,
} from "../../redux/constants";
import BackButtonWindow from "../../component/Alert/BackButtonWindow";
import Table, { TableRow } from "../../component/table";
import useDebounce from "../../Hook/useDebounce";
import Loader from "react-spinner-loader";
import { sanitizeInput } from "../../utils";
import PageSelector from "../../component/PageSelector";
import RowsPerPageSelector from "../../component/RowsPerPageSelector";

const Workflow = (props) => {
  // State for New Table
  const navigate = useNavigate();

  const [searchText, setSearchText] = useState();
  const [sort, setSort] = useState();
  const [page, setPage] = useState(1);
  const [update, setUpdate] = useState(0);
  const [loader, setLoader] = useState(false);
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("");

  const dispatch = useDispatch();
  const { tempPageName, path } = useSelector((state) => state.tempWindowsData);
  const { configurationData } = useSelector(
    (state) => state.configurationReducer
  );
  const { row_count } = useSelector((state) => state.auth);

  // Use the debounce hook to get the debounced version of the handleSearch function
  const debouncedHandleSearch = useDebounce(searchText, 300);

  const handleDelete = async (config_id) => {
    const request = {
      config_id,
      onSuccess: () => {
        setUpdate(update + 1);
      },
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content="Something went wrong. Please try again later."
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(handleDeleteConfiguration(request));
  };

  const getConfigurationByCompanyId = () => {
    setLoader(true);
    const request = {
      onError: () => {
        setLoader(false);
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content="Something went wrong. Please try again later."
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
      onSuccess: () => {
        setLoader(false);
        dispatch({ type: REMOVE_CONFIGURATION_ID });
      },
    };
    dispatch(
      getConfigurationData(
        request,
        debouncedHandleSearch,
        page,
        sortField,
        sortOrder,
        row_count
      )
    );
  };

  useEffect(() => {
    getConfigurationByCompanyId();
  }, [update, debouncedHandleSearch, page, sortField, sortOrder, row_count]);

  useEffect(() => {
    if (sort) {
      setPage(1);
      setSortField(sort.headName);
      setSortOrder(sort.type);
    }
  }, [sort]);

  const WorkflowTable = ({
    index,
    workflowItem,
    configuration_name,
    createdAt,
    configuration_desc,
  }) => {
    return (
      <TableRow
        key={index}
        row={{
          configuration_name,
          createdAt,
          configuration_desc,
        }}
        tdClass="px-2 py-2 text-sm leading-4 tracking-tight first:pl-4 text-[#1E293B] text-center first:text-left bg-[--bg-color-50] first:rounded-l-md last:rounded-r-md max-w-1/4 truncate"
      >
        <td className="px-2 py-2 whitespace-nowrap text-center text-sm bg-[--bg-color-50] rounded-r-md leading-4 tracking-tight text-[--bg-color-500] font-semibold">
          <div className="space-x-3 flex items-center justify-center">
            {/* <div title="Copy">
              <span
                className="fa-regular fa-copy text-base cursor-pointer"
                style={{ color: "#9297a2" }}
                onClick={() => {
                  navigate("/configuration/create", {
                    state: workflowItem.configuration_id,
                  });
                }}
              ></span>
            </div> */}
            {/* <div title="View">
              <span
                className="fa-light fa-eye text-base cursor-pointer"
                style={{ color: "#9297a2" }}
                onClick={() => {
                  dispatch({
                    type: WORKFLOW_HEADER_NAME,
                    payload: workflowItem.configuration_name,
                  });
                  navigate(
                    `/configuration/view/${workflowItem.configuration_id}`
                  );
                }}
              ></span>
            </div> */}
            <div title="Edit">
              <span
                className="fa-light fa-pen text-base cursor-pointer"
                style={{ color: "#9297a2" }}
                onClick={() => {
                  dispatch({
                    type: WORKFLOW_HEADER_NAME,
                    payload: workflowItem.configuration_name,
                  });
                  dispatch({
                    type: SET_WORKFLOW,
                    payload: {}
                  })
                  navigate('/workflow', { state: { configuration_id: workflowItem.configuration_id } })
                }}
              ></span>
            </div>
            <div title="Delete">
              <span
                className="fa-light fa-trash-can text-base cursor-pointer"
                style={{ color: "#eb5757" }}
                onClick={() => {
                  swal({
                    content: (
                      <CustomeModal
                        type="delete"
                        title="Are you sure?"
                        content="All of your data will be permanently removed from our servers forever. This action cannot be undone."
                        onDelete={() =>
                          handleDelete(workflowItem.configuration_id)
                        }
                      />
                    ),
                    buttons: false,
                    closeOnClickOutside: false,
                    closeOnEsc: false,
                  });
                }}
              ></span>
            </div>
          </div>
        </td>
      </TableRow>
    );
  };

  return (
    <>
      {path !== "" && tempPageName !== "" && (
        <BackButtonWindow
          backButtonName={tempPageName}
          title="Completed creating workflows?"
          path={path}
        />
      )}
      <div className="mt-4 sm:mx-6 lg:mx-8 space-y-2">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 px-6 py-4 bg-[--bg-color-50] rounded">
          <div className="space-x-4 flex items-center">
            <h4 className="text-xl leading-5 font-bold tracking-tight">
              Workflow List
            </h4>
            <SearchForm
              placeholder="Search"
              onChange={(e) => {
                const value = sanitizeInput(e.target.value);
                setSearchText(value);
              }}
              value={searchText}
            />
          </div>
          <div className="space-x-4 flex items-center justify-end">
            <button
              className="btn ml-0 md:ml-3 !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white"
              onClick={() => {
                navigate(`/workflow`);
                dispatch({
                  type: SET_WORKFLOW,
                  payload: {}
                })
              }}
            >
              <span className={`fas fa-plus mr-2`}></span>
              Create Workflow
            </button>
          </div>
        </div>
        <div className="space-y-1">
          <Table
            heads={[
              {
                headName: "Workflow Name",
                isSort: true,
                value: "configuration_name",
              },
              { headName: "Created At", isSort: true, value: "createdAt" },
              {
                headName: "Description",
                isSort: true,
                value: "configuration_desc",
              },
              { headName: "Action", isSort: false, value: "Action" },
            ]}
            tClass="table-fixed w-full border-separate border-spacing-y-2"
            hClass="text-sm leading-2 tracking-tight font-semibold text-[#1E293B] bg-[--bg-color-50]"
            bClass="text-sm"
            thClass={`px-2 py-3 whitespace-nowrap first:text-left text-center font-semibold first:pl-4 first:rounded-l-md last:rounded-r-md max-w-1/4`}
            setSort={setSort}
            sort={sort}
          >
            {loader ? (
              <tr className="px-2 py-3 whitespace-nowrap">
                <td colSpan={4}>
                  <div className="flex justify-center p-2 my-2 whitespace-nowrap w-full">
                    <Loader show={loader} />
                  </div>
                </td>
              </tr>
            ) : configurationData?.data?.length > 0 ? (
              configurationData.data.map((workflowItem, index) => {
                const { configuration_name, configuration_desc } = workflowItem;
                const createdAt = moment(workflowItem.createdAt).format(
                  "DD MMM, YYYY - HH:mm a"
                );
                return (
                  <WorkflowTable
                    index={index}
                    workflowItem={workflowItem}
                    configuration_name={configuration_name}
                    createdAt={createdAt}
                    configuration_desc={configuration_desc}
                  />
                );
              })
            ) : (
              <td
                colSpan={4}
                className="text-center py-2 text-lg text-[#1E293B] tracking-tight leading-4"
              >
                There are no records to display
              </td>
            )}
          </Table>
          {!loader && configurationData?.data?.length > 0 && (
            <div className="flex justify-between items-center">
              <RowsPerPageSelector />
              <PageSelector
                rowPerPage={row_count}
                page={page}
                setpage={(newPage) => {
                  setPage(newPage);
                }}
                totalDataCount={
                  configurationData ? configurationData.totalCount : 0
                }
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

Workflow.auth = { path: "/configuration/overview", role: "super-admin admin" };
export default Workflow;
